import type {SuggestLocation, SuggestObject} from '@yandex-delivery/api/model/suggest'
import type {Point} from '@yandex-delivery/core/types'
import {Suggest} from '@yandex-delivery/ui'
import React from 'react'

import {useConfig} from '../../../../../../config'
import styleClasses from './classes.module.css'

export type Props = {
  coordinates?: SuggestLocation
  errorMessage?: string
  location: Point
  onChange?: (object?: SuggestObject, inputValue?: string) => void
  placeholder?: string
}

export function AddressSuggest({
  coordinates,
  errorMessage = '',
  location,
  onChange,
  placeholder = '',
}: Props): React.ReactElement {
  const {suggestService} = useConfig()

  return (
    <div className={styleClasses.suggestWrapperStyled}>
      <Suggest<SuggestObject>
        description={errorMessage}
        // @ts-expect-error PointType из suggestService взят не из @yandex-taxi/react-integration-api, а используется самописный
        fetchSuggest={suggestService.fetchAddressSuggest}
        label={placeholder}
        location={location}
        onChange={onChange}
        point={coordinates}
        pointType="a"
      />
    </div>
  )
}
